import React from 'react';
import _ from 'lodash';
import {Column, Row} from "../styled/flex";
import {ConnectedChatList} from "./ChatList";
import './Main.scss';
import firebase from 'firebase';

export const Main = ({style, className = ''}) => <Column style={style} className={"main " + className}>

  <ConnectedChatList />

  <button
    style={{
      alignSelf: 'flex-start',
      marginTop: 12
    }}
    onClick={() => firebase.auth().signOut()}
  >log out</button>
  <button
    style={{
      alignSelf: 'flex-start',
      marginTop: 12
    }}
    onClick={() => {
      firebase.auth().sendPasswordResetEmail(firebase.auth().currentUser.email);
      window.alert(`Please check your e-mail: ${firebase.auth().currentUser.email}`);
    }}
  >change password</button>
</Column>;
